import React from 'react'
import styles from './StationTrajectoryPanel.module.css'

export const StationTrajectoryPanel = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>{children}</div>
        </div>
    )
}
